import '../../../js/subject-management/add-card';
import '../../../js/subject-management/batch';
import '../../../js/subject-management/card';
import '../../../js/subject-management/subject-image-dialog';
import '../../../js/subject-management/subject-management';
import '../../../js/subject-management/utils';